import { createFileRoute } from "@tanstack/react-router";
import { HelpHubContent } from "@/routes/help/index";

export const Route = createFileRoute("/dashboard/help/")({
	component: HelpHubContent,
});
